import React from "react"
import { Link } from "gatsby"
import activityListStyles from "../styles/components/activity-list.module.scss"
import Img from 'gatsby-image'
import ActivityTags from "./ActivityTags"
// import ActivityKey from "./ActivityKey"

const ActivityList = ({ edges }) => {
  const blogData = edges
    return (
      <section>
      <ul className={activityListStyles.list}>
        {blogData
          .filter(blog => blog.node.frontmatter.title !== "")
          .map(blog => {
            return (
              <li className={activityListStyles.list__item} key={blog.node.id}>
                <div className={activityListStyles.list__container} >
                  <Link to={blog.node.fields.slug} >
                    <div className={activityListStyles.list__hero}>
                      <Img 
                        fluid={
                          blog.node.frontmatter.hero_image.childImageSharp.fluid
                        }
                        alt={blog.node.frontmatter.title}
                      />
                    </div>
                    <div className={activityListStyles.list__info}>
                      <h2>{blog.node.frontmatter.title}</h2>
                      <p>{blog.node.frontmatter.description}</p>
                    </div>
                  </Link>
                </div>
                {blog.node.frontmatter.tags && blog.node.fields.tagSlugs && <ActivityTags tags={blog.node.frontmatter.tags} tagSlugs={blog.node.fields.tagSlugs} />}
              </li>
              )
          })} 
      </ul>
      
    </section>
    )
  }

export default ActivityList;

// <ActivityKey />